module.exports = __webpack_public_path__ + "img/IconeLink.98bad8d4.png";